import { AppContext, BookingData } from "../../../../../App/AppDataProvider/AppDataProvider";
import { getCurrencyDisplay as baseGetCurrencyDisplay, requireBookingDataFields } from "../../../../utils";
import { paymentValidationRequiredFields, ValidatedSummary } from "./ValidatedSummary/ValidatedSummary";
import React, { useContext } from "react";
import { BookingPrice } from "./getBookingPrices/getBookingPrices";
import { PartRequired } from "@src/App/utils/types";
import { UnvalidatedSummary } from "./UnvalidatedSummary/UnvalidatedSummary";
import { useTranslation } from "react-i18next";
export type PriceInfoProps = {
  bookingPrices: BookingPrice[];
};
type PriceInfoBookingData = PartRequired<BookingData, "organisation" | "service">;
export function PriceInfo({
  bookingPrices
}: PriceInfoProps) {
  const {
    i18n
  } = useTranslation();
  const locale = i18n.language;
  const {
    appData
  } = useContext(AppContext);
  const {
    bookingData
  } = appData;
  requireBookingDataFields<PriceInfoBookingData>(bookingData, ["organisation", "service"]);
  const {
    currency
  } = bookingData.organisation;
  function getCurrencyDisplay(value: number) {
    if (bookingData.duration?.POA) return "POA";
    return baseGetCurrencyDisplay(value, currency, locale);
  }
  const canValidatePrice = paymentValidationRequiredFields.every(fieldName => typeof bookingData[fieldName] !== "undefined");
  const childProps = {
    bookingPrices,
    getCurrencyDisplay
  };
  return canValidatePrice ? <ValidatedSummary {...childProps} /> : <UnvalidatedSummary {...childProps} />;
}
export default PriceInfo;